
import axios from "axios";
import { API_URL } from "./urls";

axios.defaults.baseURL = API_URL;



// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    console.log("添加请求数据", config)

    const token = localStorage.getItem("adtoken");
    config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data

    console.log("拦截器响应", response.headers)
    const { authorization } = response.headers;
    authorization && localStorage.setItem("adtoken", authorization);

    return response;
  },
  function (error) {
    //任何超出2xx范围的状态代码都会触发此功能
    //处理响应错误
    const { status } = error.response;
    if (status === 401) {
      console.log("登录已失效")

      localStorage.removeItem("adtoken");
      window.location.href = "#/login";
    }
    return Promise.reject(error);
  }
);
